import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./useInformationForm.gql"

export const useInformationForm = (props) => {
  const formApiRef = useRef(null)
  const {
    appointmentData, isUpdate, formDataId 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    updatelAppointmentsMutation, addAppointmentsMutation 
  } = operations

  const [isLoading, setIsLoading] = useState(false)

  const setFormApi = useCallback((api) => (formApiRef.current = api), [])

  const [addAppointments, {
    data 
  }] = useMutation(
    isUpdate ? updatelAppointmentsMutation : addAppointmentsMutation,
    {
      fetchPolicy: "no-cache",
    }
  )

  const handleSubmit = useCallback(async (formState) => {
    const values = formState.values

    values.appointmenttype = appointmentData.type
    values.appointmentdate = appointmentData.date
    values.appointmentweek = appointmentData.week
    values.appointmenttime = appointmentData.time
    values.timezone = appointmentData.timezone

    if (isUpdate) {
      values.id = formDataId
    }

    setIsLoading(true)

    try {
      await addAppointments({
        variables: values,
      })
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error(error)
      }
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    setFormApi,
    isLoading,
    handleSubmit,
    response:
            data && (isUpdate ? data.updateAppointments : data.addAppointments),
  }
}
